import { Route } from 'react-router-dom';
import ImportParrainages from './importParraianges';
/**
 * Routes configurées pour le module ParrainageView
 */
const ImportParrainagesRoutes = [
    <Route
        key="parrainage-view-main-data-parrainages"
        path="importParrainages"
        element={<ImportParrainages />}
    />,
];

export default ImportParrainagesRoutes;